import React from 'react';
import { Section } from './Section';
import { CtaButton } from './CtaButton';
import { ComparisonTable } from './ComparisonTable';
import { closeRows } from '../data/comparisons';
import { offer } from '../data/offer';
const recap = ['Accueil', 'Diagnostic', 'Croyances', 'Passage à l’action', 'Stagnation', 'Clôture', 'Pratique en France'];
export function Close() {
  return <Section tone="graphite" labelledBy="cloture-title" data-id="element-42" data-mp="1l0ostv5sw6q9">
      <div className="mx-auto max-w-4xl" data-id="element-43" data-mp="1l29mlikajln2">
        <h2 id="cloture-title" className="font-serif text-3xl font-semibold leading-[1.15] text-creme md:text-[2.75rem]" data-id="element-44" data-mp="1g8wxz8fm3eub">
          Le parcours de vos clients mérite mieux qu’une suite de bonnes
          conversations.
        </h2>
        <p className="mt-8 max-w-prose text-base leading-relaxed text-creme/70 md:text-lg" data-id="element-45" data-mp="176nsiwz7abns">
          Travaillez comme un coach qui a un cadre : une feuille de route dès la
          Séance Zéro, un progrès visible au début de chaque séance, un bilan
          que le client formule lui-même.
        </p>

        <ul className="mt-8 flex flex-wrap gap-x-2 gap-y-2" data-id="element-46" data-mp="3vdkatkmq97uo">
          {recap.map(item => <li key={item} className="border border-warm-lineDark px-3 py-1.5 text-xs text-creme/70" data-id="element-47" data-mp="42kcl5xl60gx">
              {item}
            </li>)}
        </ul>

        <div className="mt-14" data-id="element-48" data-mp="i0io83kivisq">
          <ComparisonTable rows={closeRows} beforeLabel="Sans cadre" afterLabel="Avec le système" tone="dark" caption="Travailler sans cadre ou avec le système" data-id="element-49" data-mp="i08y8fzh9bn1" />
        </div>

        <p className="mt-14 font-serif text-xl italic leading-relaxed text-creme md:text-2xl" data-id="element-50" data-mp="84fby4vyi3s2">
          Avant votre prochain premier rendez-vous. Pas après le troisième
          décrochage.
        </p>

        <div className="mt-10 border-t border-warm-lineDark pt-10" data-id="element-51" data-mp="2suo4tnj6vtti">
          <p className="text-sm text-creme/70" data-id="element-52" data-mp="2xsg1svyoy64k">
            {offer.name} — 6 tomes + 5 bonus · {offer.price} {offer.currency} ·
            paiement unique
          </p>
          <div className="mt-6" data-id="element-53" data-mp="z9b8ogai2723">
            <CtaButton href={offer.checkoutUrl} tone="light" data-id="element-54" data-mp="zacrx81o5zuw">
              Oui, je veux Le Système Complet du Coach
            </CtaButton>
          </div>
          <p className="mt-5 text-xs text-creme/60" data-id="element-55" data-mp="pkjiodp01wtt">
            Paiement 100 % sécurisé · Accès immédiat · Garantie de{' '}
            {offer.guaranteeDays} jours
          </p>
        </div>

        <p className="mt-14 text-sm uppercase tracking-[0.18em] text-creme/60" data-id="element-56" data-mp="gjl9zi3m914w">
          Comprendre · Aligner · Prouver.
        </p>
      </div>
    </Section>;
}